/**
 * axios setup to use mock service
 */

import axios from 'axios';

const mockAxiosServices = axios.create();

// interceptor for http
mockAxiosServices.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject((error.response && error.response.data) || 'Wrong Services')
);

export default mockAxiosServices;
